var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/UserClassifierTree.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { ApiDomain } from '../domain';
import { Id } from '../Id';
import { Version } from '../Version';
import { ElementProperty } from './DynamicGroup';
export var UserClassifierTree;

(function (_UserClassifierTree) {
  var domain = ApiDomain.domain('UserClassifierTree', {
    name: "domain",
    sid: "9np9jp"
  });
  var GroupItem;

  (function (_GroupItem) {
    var io = _GroupItem.io = t.type({
      id: Id,
      parentGroupId: t.union([Id, t["null"]])
    });
    var ListResponse = _GroupItem.ListResponse = t.type({
      groupTree: t.array(io)
    });
    var getList = _GroupItem.getList = ApiCallService.create({
      name: 'getList',
      parentDomain: domain,
      result: ListResponse,
      getKey: ['classifierId', 'classifierVersion']
    });
  })(GroupItem || (GroupItem = _UserClassifierTree.GroupItem || (_UserClassifierTree.GroupItem = {})));

  var DynamicGroupItem;

  (function (_DynamicGroupItem) {
    var DynamicGroupConditionItem = _DynamicGroupItem.DynamicGroupConditionItem = t.type({
      sourceGroupId: Id,
      classifierId: Id,
      classifierVersion: Version,
      id: Id,
      groupingConditions: t.array(ElementProperty.io)
    });
    var DynamicGroupConditionList = _DynamicGroupItem.DynamicGroupConditionList = t.type({
      dynamicGroupList: t.array(DynamicGroupConditionItem)
    });
    var getList = _DynamicGroupItem.getList = ApiCallService.create({
      name: 'getList',
      parentDomain: domain,
      result: DynamicGroupConditionList,
      getKey: ['classifierId', 'classifierVersion']
    });
  })(DynamicGroupItem || (DynamicGroupItem = _UserClassifierTree.DynamicGroupItem || (_UserClassifierTree.DynamicGroupItem = {})));
})(UserClassifierTree || (UserClassifierTree = {}));